import { CAMPAIGN_NAME_FILTER } from '../constants';
import type { GetCampaignsParams, RowStatus } from '../api';
import type { MarketingProcess } from 'types/shared';
import { isScalingEgProcess } from './marketingProcess';

export const SCALING_EG_CAMPAIGN_STATUS: RowStatus = 'ACTIVE';

export const buildCampaignFetchParams = (
  marketingProcess: string | undefined,
  facebookAccountId: string[],
): GetCampaignsParams => ({
  facebookAccountId,
  campaignNameFilter: CAMPAIGN_NAME_FILTER[marketingProcess as MarketingProcess] ?? '',
  ...(isScalingEgProcess(marketingProcess)
    ? { status: SCALING_EG_CAMPAIGN_STATUS }
    : {}),
});
